import { Card, CardBody } from '@nextui-org/react'

import { useTankInfoModalStore } from '../../store/tankInfo/useTankInfoModalStore'

export interface EmptyCardProps {
  tankId: string
  tankName: string
}

export default function EmptyCard({ tankName, tankId }: EmptyCardProps) {
  const { open, setTank } = useTankInfoModalStore()
  const onOpenTankInfo = () => {
    setTank(tankId, tankName)
    open()
  }

  return (
    <Card
      className="bg-tdpllightgrey border-1 border-tdpldarkgrey border-opacity-60 empty-card rounded-lg"
      style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', borderRadius: '0.75rem' }}
      radius="lg"
      isPressable
      isHoverable
      onPress={onOpenTankInfo}
    >
      <CardBody className="empty-card-body">
        <p className="text-tdpldark font-bold empty-card-text">{tankName}</p>
      </CardBody>
    </Card>
  )
}
